import { __assign } from "tslib";
import React from 'react';
import cn from 'classnames';
import { BUTTON_TYPES } from 'wix-rich-content-editor-common';
import IconButton from '../../../Button/IconButton';
import s from './ExternalToolbar.scss';
var Button = function (_a) {
    var onClick = _a.onClick, getIcon = _a.getIcon, dataHook = _a.dataHook, isDisabled = _a.isDisabled, isActive = _a.isActive, tooltip = _a.tooltip, forceTheme = _a.forceTheme, onPluginClick = _a.onPluginClick;
    var Icon = getIcon();
    return (React.createElement(IconButton, { disabled: isDisabled(), "data-hook": dataHook, onClick: function (e) {
            onPluginClick && onPluginClick();
            onClick(e);
        }, "aria-label": tooltip, tooltipText: tooltip, tooltipTheme: forceTheme, className: cn(s['button'], s["button-" + dataHook]) },
        React.createElement(Icon, null)));
};
var ExternalToolbar = function (_a) {
    var buttons = _a.buttons, className = _a.className, forceTheme = _a.forceTheme, onPluginClick = _a.onPluginClick;
    return (React.createElement("div", { className: cn(s['wrapper'], className) }, Object.values(buttons).map(function (buttonProps) {
        return buttonProps.type === BUTTON_TYPES.FILE ? null : (React.createElement(Button, __assign({ key: buttonProps.dataHook }, buttonProps, { onPluginClick: onPluginClick, forceTheme: forceTheme })));
    })));
};
ExternalToolbar.displayName = 'ExternalToolbar';
export default ExternalToolbar;
//# sourceMappingURL=ExternalToolbar.js.map